import { BaseMdl } from './BaseMdl';

export class userMdl {
    corp_id: number = 0;
    corp_name: string = '';
    user_id: number = 0;
    user_account: string = '';
    user_name: string = '';
    mail_address: string = '';
    authority: number = 0;
    map_style: string = 'Nature';

    constructor(init?: Partial<userMdl>) {
        Object.assign(this, init);
    }

    public static toJsonDataOnModel(data: any): any {
        return BaseMdl.toJsonOnModel(new userMdl(), data);
    }
}

export class loginUserMdl {
    corp_id: number = 0;
    user_id: number = 0;
    user_account: string = '';
    user_name: string = '';
    authority: number = 0;

    constructor(init?: Partial<loginUserMdl>) {
        Object.assign(this, init);
    }

    public static toJsonDataOnModel(data: any): any {
        return BaseMdl.toJsonOnModel(new loginUserMdl(), data);
    }
}
